/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Active_TicketInputs */

const en_vault_active_ticket = /** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Event Ticket`)
};

const es_vault_active_ticket = /** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket de Evento Activo`)
};

const fr_vault_active_ticket = /** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket d'événement actif`)
};

const de_vault_active_ticket = /** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktives Event-Ticket`)
};

const id_vault_active_ticket = /** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket Acara Aktif`)
};

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const ja_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const zh_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const ar_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const it_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const ru_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const pt_vault_active_ticket = en_vault_active_ticket;

/** @type {(inputs: Vault_Active_TicketInputs) => LocalizedString} */
const ko_vault_active_ticket = en_vault_active_ticket;

/**
* | output |
* | --- |
* | "Active Event Ticket" |
*
* @param {Vault_Active_TicketInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_active_ticket = /** @type {((inputs?: Vault_Active_TicketInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Active_TicketInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_active_ticket(inputs)
	if (locale === "es") return es_vault_active_ticket(inputs)
	if (locale === "fr") return fr_vault_active_ticket(inputs)
	if (locale === "de") return de_vault_active_ticket(inputs)
	if (locale === "ja") return ja_vault_active_ticket(inputs)
	if (locale === "zh") return zh_vault_active_ticket(inputs)
	if (locale === "ar") return ar_vault_active_ticket(inputs)
	if (locale === "id") return id_vault_active_ticket(inputs)
	if (locale === "it") return it_vault_active_ticket(inputs)
	if (locale === "ru") return ru_vault_active_ticket(inputs)
	if (locale === "pt") return pt_vault_active_ticket(inputs)
	return ko_vault_active_ticket(inputs)
});